import {useTranslation} from "next-i18next"
import {useRouter} from "next/router"
import React, {useContext, useState} from "react"
import {ChevronDown, ChevronUp} from "react-bootstrap-icons"
import slugify from "slugify"
import {CollectionName} from "../../constants"
import LayoutContext from "../../context/LayoutContext"
import NavDropdownItem from "../navigation/desktop/NavDropdownItem"
import Dropdown from "../reusable/components/Dropdown/Dropdown"
import Typography from "../reusable/Typography/Typography"
import Image from "next/image"
import {getSortedOrderLabel} from "../../utility/Helper"
import Spinner from "../reusable/Spinner"
import FilterContext from "../../context/FilterContext"

type Props = {
  classGroup?: string,
  collectionName: CollectionName
  customUrlBaseValue?: string
}

const ProductSort: React.FC<Props> = ({classGroup, collectionName, customUrlBaseValue}) => {
	const {t} = useTranslation(["common"])
	const {isMobile} = useContext(LayoutContext)
	const [isOpen, setIsOpen] = useState(false)
	const router = useRouter()
	const params = router.query
	const capitalizedSortValue = params.sortOrder && params.sortOrder[0].toUpperCase() + params.sortOrder.slice(1)
	const [sortValue, setSortValue] = useState(capitalizedSortValue)
	const navItems = dropDownSort.items
	const {filtersLoading} = useContext(FilterContext)

	const handleMouseEnter = () => {
		setIsOpen(true)
	}

	const handleMouseLeave = () => {
		setIsOpen(false)
	}

	const handleClick = itemLabel => {
		setIsOpen(false)
		if (itemLabel === "Gunstigste") {
			setSortValue("Günstigste")

			return
		}

		setSortValue(itemLabel)
	}

	return (
		<>
			{isMobile ? <div className={`px-0 mt-4 ${!isOpen && "border-bottom"}`}
				style={{paddingBottom: isOpen ? "" : 18, marginBottom: 10}}>
				<div className="d-flex align-items-start justify-content-between cursor-pointer"
					onClick={() => {
						setIsOpen(prevState => !prevState)
					}}>
					<div>
						<Typography variant="bodyLgBold"
							semanticTag="h3"
							className="m-0">
							{`${t("Sortieren nach")} `}:
						</Typography>
						<Typography variant="bodyXSm"
							semanticTag="p"
							className="mb-0"
							style={{color: "#6C7074"}}>{getSortedOrderLabel(params, t)}</Typography>
					</div>
					<div className={"col-auto"}>
						{isOpen ? <ChevronUp/> : <ChevronDown/>}
					</div>
				</div>
				<div className={`accordion-collapse collapse ${isOpen ? "show" : null}`}>
					<div className="bg-white pt-1">
						<div className="px-0">
						</div>
						<ul style={{minWidth: "204px"}}
							className="bg-white px-2 pt-2 row list-unstyled">
							{navItems.map(({itemLabel, href}) =>
								<div key={itemLabel}
									onClick={() => handleClick(itemLabel)}
									className="px-1">
									<NavDropdownItem
										onClick={() => handleClick(itemLabel)}
										customUrlBaseValue={customUrlBaseValue}
										collectionName={collectionName}
										href={href === "/faq" ? `/faq${t("/konzept")}` : slugify(t(href))}
										label={itemLabel}
										key={itemLabel}
										sortList
										sortValue={sortValue}/>
								</div>)}
						</ul>
					</div>
				</div>
			</div> : <li style={{zIndex: 5000}}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				className={"position-relative pointer col-auto p-2 p-md-0 list-unstyled"}>
				<span>
					<Typography variant="bodySmBold"
						semanticTag="span"
						className="me-2 pe-1">
						{t("Sortieren nach")}:
					</Typography>

					<Typography variant="bodySm"
						semanticTag="span"
						className={`${classGroup} me-1 pe-1`}><span className="d-inline-block">{getSortedOrderLabel(params, t)}</span>
					</Typography>
					{filtersLoading ? <span className="d-inline-block"><Spinner size="sm"/> </span> : <Image src="/assets/icons/chevron-down.svg"
						alt="arrow down"
						width={12}
						height={6.5}/>}
				</span>
				<Dropdown top={25}
					left={-20}
					isOpen={isOpen}
					sortList>
					<ul style={{minWidth: "204px"}}
						className="bg-white border px-2 py-2 row rounded rounded-2 shadow list-unstyled">
						{navItems.map(({itemLabel, href}) =>
							<div key={itemLabel}
								onClick={() => handleClick(itemLabel)}
								className="px-1">
								<NavDropdownItem
									onClick={() => handleClick(itemLabel)}
									customUrlBaseValue={customUrlBaseValue}
									collectionName={collectionName}
									href={href === "/faq" ? `/faq${t("/konzept")}` : slugify(t(href))}
									label={itemLabel}
									key={itemLabel}
									sortList
									sortValue={sortValue}/>
							</div>)}
					</ul>
				</Dropdown>
			</li>}
		</>
	)
}

export default ProductSort

const dropDownSort = {
	label: "Sorting",
	items: [
		{itemLabel: "Relevanz", href: "relevanz"},
		{itemLabel: "Neuestes", href: "neuestes"},
		{itemLabel: "Günstigste", href: "günstigste"},
		{itemLabel: "Teuerste", href: "teuerste"},
		{itemLabel: "Sale", href: "sale"}
	]
}

